<div class="w-100 my-2">
  <div class="alert alert-danger" *ngIf="errorMsg">
    {{ errorMsg }}
  </div>
  <div class="d-flex">
  <form [formGroup]="weatherForm" (ngSubmit)="getWeather()" novalidate>
    <div class="form-row">
      <div class="col-md-3 mb-3">
        <label for="startDate">Start Date:</label>
        <input
          type="datetime-local"
          class="form-control"
          id="startDate"
          formControlName="startDate"
          required
        />
      </div>
      <div class="col-md-3 mb-3">
        <label for="endDate">End Date:</label>
        <input
          type="datetime-local"
          class="form-control"
          id="endDate"
          formControlName="endDate"
          required
        />
      </div>
      <div class="col-md-3 mb-3">
        <label for="weatherServiceName">Weather Service:</label>
        <select class="form-control" formControlName="weatherServiceName">
          <option *ngFor="let service of weatherServiceNames" [value]="service">
            {{ service }}
          </option>
        </select>
      </div>
      <div class="col-md-3 mb-3">
        <label for="searchRadiusMiles">Search Radius (miles):</label>
        <input
          type="number"
          class="form-control"
          formControlName="searchRadiusMiles"
          required
        />
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-3 mb-3">
        <label for="latitude">Latitude:</label>
        <input
          type="number"
          class="form-control"
          formControlName="latitude"
          required
        />
      </div>
      <div class="col-md-3 mb-3">
        <label for="longitude">Longitude:</label>
        <input
          type="number"
          class="form-control"
          formControlName="longitude"
          required
        />
      </div>
      <div class="col-md-3 mb-3">
        <label for="maxChosenStations">Max Chosen Stations:</label>
        <input
          type="number"
          class="form-control"
          formControlName="maxChosenStations"
          required
        />
      </div>
      <div class="col-md-3 mb-3">
        <label for="maxQueryStations">Max Query Stations:</label>
        <input
          type="number"
          class="form-control"
          formControlName="maxQueryStations"
          required
        />
      </div>
    </div>
    <button
      type="submit"
      class="btn btn-primary mr-2"
      [disabled]="!weatherForm.valid"
    >
      <i [ngClass]="bProcessing ? 'fa fa-spinner fa-spin' : 'fa fa-cloud'"></i
      >&nbsp;Get Weather
    </button>
    <ng-content></ng-content>
  </form>
</div>
  <div *ngIf="weatherResult" class="mt-4">
    <tabset class="p-0 m-0">
      <tab heading="Stations">
        <div *ngFor="let station of weatherResult" class="p-2 border-left border-right border-bottom">
          <div class="card">
            <div class="card-header">
              <h5 class="mr-4">{{ station.name }} ({{ station.stationId }})</h5>
              <div class="text-secondary font-italic">
                <span class="mr-2"><strong>Distance:</strong> {{ station.distanceMiles| number:'1.2-2' }} miles</span>
                <span class="mr-2"><strong>Elevation:</strong> {{ station.elevation| number:'1.2-2' }} {{ station.elevationUnit }}</span>
                <span class="mr-2"><strong>Latitude,Longitude:</strong> {{ station.latitude }},{{ station.longitude }}</span>
                <span class="mr-2"><strong>Observations:</strong> {{ station.observations?.length }}</span>
              </div>
            </div>
            <table class="table m-0 px-1" *fesListView="let observations of station.observations">
              <thead>
                <tr>
                  <th fesSortField="date">Date</th>
                  <th fesSortField="airTemp" [sortType]="'numeric'">Temp &#8457;</th>
                  <th fesSortField="airTemp" [sortType]="'numeric'">Temp &#8451;</th>
                  <th fesSortField="dewPointTemp" [sortType]="'numeric'">Dew Point Temp</th>
                  <th fesSortField="pressure" [sortType]="'numeric'">Pressure</th>
                  <th fesSortField="seaLevelPressure" [sortType]="'numeric'">Sea Level Pressure</th>
                  <th fesSortField="relativeHumidity" [sortType]="'numeric'">Relative Humidity</th>
                  <th fesSortField="windSpeed" [sortType]="'numeric'">Wind Speed</th>
                  <th fesSortField="windDirection" [sortType]="'numeric'">Wind Direction</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let observation of observations">
                  <td>{{ observation.date }}</td>
                  <td>{{ observation.airTemp| number:'1.2-2' }}</td>
                  <td>{{ ((observation.airTemp -32) * 5/9) | number:'1.2-2' }}</td>
                  <td>{{ observation.dewPointTemp| number:'1.2-2' }}</td>
                  <td>{{ observation.pressure| number:'1.2-2' }}</td>
                  <td>{{ observation.seaLevelPressure| number:'1.2-2' }}</td>
                  <td>{{ observation.relativeHumidity | number:'1.2-2' }}%</td>
                  <td>{{ observation.windSpeed| number:'1.2-2' }}</td>
                  <td>{{ observation.windDirection }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </tab>
      <tab heading="JSON">
        <pre>{{ weatherResult | json }}</pre>
      </tab>
    </tabset>
  </div>
</div>
